<template>
    <div>
        <v-container>
            <div class="text-h5 text-sm-h5 text-md-h4 text-lg-h4 ma-3 text-xl-h4 text-center">
                Albaranes
            </div>

            <v-expansion-panels v-model="activePanels">
                <v-expansion-panel style="background-color: #F5F5F5" @click.prevent="toogleFilters">
                    <v-expansion-panel-header>
                        <span class="header">Filtros</span>
                        <template v-slot:actions>
                            <v-btn icon @click.stop="toogleFilters">
                                <v-icon>mdi-menu-down</v-icon>
                            </v-btn>
                        </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-form :disabled="loading">
                            <v-row>
                                <v-col class="mb-n7" cols="6" sm="5" md="3" lg="3" xl="2">
                                    <DateFind label="Desde" v-model="filtros.FechaDesde"></DateFind>
                                </v-col>

                                <v-col class="mb-n7" cols="6" sm="5" md="3" lg="3" xl="2">
                                    <DateFind label="Hasta" v-model="filtros.FechaHasta"></DateFind>
                                </v-col>

                                <v-col cols="12" sm="7" md="5" lg="5" xl="3">
                                    <ProovedoresArtProvFind class="mb-n7" ref="provCtrl" 
                                        v-model="filtros.Proveedor" label="Proveedor"
                                        :dirId="this.dirId">
                                    </ProovedoresArtProvFind>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
            

            <v-btn
            @click="openCreateDialog"
            color="primary"
            class="mt-5 mb-3">
            Nuevo
            </v-btn>

            <v-data-table
                :headers="headers"
                :items="dataRows"
                :options.sync="options"
                :footer-props="{itemsPerPageOptions: [15, 30, 50, 100],disablePagination:loading, disableItemsPerPage: loading}"
                :server-items-length="totalDataRows"
                :loading="loading"
                @click:row="onClickRowEditarAlbaran"
                style="overflow: scroll"
                mobile-breakpoint="0"
                class="elevation-1"
                dense
                >
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.Fecha="{ item }">
                    {{ formatDate(item.Fecha) }}
                </template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.Pedido.Proveedor="{ item }">
                    <span v-if="item.Pedido != null">{{ item.Pedido.Proveedor }}</span>
                    <span v-else>{{ item.Proveedor }}</span>
                </template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.Enviado="{ item }">
                    <v-simple-checkbox v-model="item.Enviado" disabled></v-simple-checkbox>
                </template>
            </v-data-table>
        </v-container>

        <!-- Modal new -->
        <v-dialog
          v-model="showCreateDialog"
          transition="dialog-bottom-transition"
          persistent eager
        >
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              NUEVO ALBARAN
            </v-card-title>

            <v-card-text class="mt-2">
              <v-tabs v-model="tab" background-color="transparent" show-arrows>
                <v-tabs-slider color="blue"></v-tabs-slider>
                <v-tab href="#tab-ped">Pedidos</v-tab>
                <v-tab href="#tab-pro">Recuperar Albaran</v-tab>
                <v-tab href="#tab-nuevo">Crear nuevo albaran</v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab" touchless>
              <v-tab-item :value="'tab-ped'" eager>
                <v-card flat>
                  <h3>* Selecciona el pedido sobre el que quieres crear el albarán</h3>
                  <PedidosSearch ref="pedidosSearch" :dirId="dirId" :loading="loading" @selected="onSelect" :pedidoFiltro="1"></PedidosSearch>
                </v-card>
              </v-tab-item>
              <v-tab-item :value="'tab-pro'">
                <v-card flat>
                  <h3>* Selecciona el proveedor sobre el que quieres recuperar el albarán</h3>

                  <ProovedoresArtProvFind
                    class="mb-n7"
                    ref="provCtrl"
                    v-model="newPedidoProveedor"
                    label="Proveedor"
                    :onlyObradorTostados="true"
                    :dirId="this.dirId"
                  />

                  <br />

                  <!-- Si NO es TAHONA mostramos Nº de albarán -->
                  <v-row v-if="!isTahona">
                    <v-text-field
                      class="mb-n7"
                      outlined
                      dense
                      text
                      type="text"
                      v-model="numeroAlbaran"
                      label="Número Albarán"
                    />
                  </v-row>

                  <!-- Si es TAHONA (0008) mostramos FECHA -->
                  <v-row v-else>
                    <v-text-field
                      class="mb-n7"
                      outlined
                      dense
                      type="date"
                      v-model="fechaAlbaran"
                      label="Fecha Albarán"
                    />
                  </v-row>

                  <v-btn
                    @click="onClickNewPedido"
                    color="primary"
                    class="mt-5 mb-3"
                    :disabled="newPedidoProveedor == null || disabledCrear"
                    :loading="loading"
                  >
                    Crear
                  </v-btn>
                </v-card>
              </v-tab-item>
              <!-- <v-tab-item :value="'tab-pro'">
                <v-card flat>
                   <h3>* Selecciona el proveedor sobre el que quieres recuperar el albarán</h3>
                   <ProovedoresArtProvFind class="mb-n7" ref="provCtrl" 
                      v-model="newPedidoProveedor" label="Proveedor"
                      :dirId="this.dirId">
                  </ProovedoresArtProvFind>
                  <br>
                  <v-row>
                    <v-text-field
                    class="mb-n7" outlined dense text
                    type="text"
                    v-model="numeroAlbaran"
                    label="Numero Albaran"
                    > 
                    </v-text-field>
                  </v-row>
                  <v-btn @click="onClickNewPedido"
                  color="primary" class="mt-5 mb-3" 
                  :disabled="newPedidoProveedor == null || numeroAlbaran == ''" :loading="loading">
                  Crear
                  </v-btn>
                </v-card>
              </v-tab-item> -->

              <v-tab-item :value="'tab-nuevo'">
                <v-card flat>
                   <h3>* Selecciona el proveedor sobre el que quieres crear el albarán</h3>
                   <ProovedoresArtProvFind class="mb-n7" ref="provCtrl" 
                      v-model="newPedidoProveedor" label="Proveedor"
                      :dirId="this.dirId">
                  </ProovedoresArtProvFind>
                  <br>
                  <v-btn @click="onClickNewPedido"
                  color="primary" class="mt-5 mb-3" 
                  :disabled="newPedidoProveedor == null" :loading="loading">
                  Crear
                  </v-btn>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                @click="onBtnClose"
              >
                Cerrar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </div>
</template>

<script>

import axios from "axios";
import funcs from "../../funcs";
import { mapState } from "vuex";
import DateFind from "../../components/DateFind.vue";
import ProovedoresArtProvFind from "../../components/ArtProv/ProovedoresArtProvFind.vue";
import PedidosSearch from "../../components/PedidosSearch.vue";

export default ({
    components: {
        DateFind, ProovedoresArtProvFind, PedidosSearch
    },
    computed: {
      ...mapState(['empId', 'dirId', 'perId', 'perIdAux', 'urlRaiz']),
      isTahona() {
        const p = this.newPedidoProveedor
        if (!p) return false
        // En tu ProovedoresArtProvFind veo que usas xproveedor_id y xnomabrev
        const code = p.xproveedor_id || p.ProveedorId || p.proveedorId || p.codigo || p.Codigo || p.id
        const name = (p.xnomabrev || p.Nombre || p.nombre || '').toUpperCase()
        return code === '0008' || name.includes('TAHONA')
      },
      disabledCrear() {
        // Si es TAHONA exige fecha; si no, exige número
        return this.isTahona ? !this.fechaAlbaran : !this.numeroAlbaran
      },    
    },
    data () {
        return {
            loading: false,
            activePanels: 0,
            tab: null,
            showCreateDialog: false,
            totalDataRows: 0,
            dataRows: [],
            options: {itemsPerPage: 15},
            headers: [
                { text: 'Fecha', width: 50, sortable: false, value: 'Fecha' },
                { text: 'Proveedor', width:300, sortable: false, value: 'Pedido.Proveedor' },
                { text: 'Creado por', width:300, sortable: false, value: 'Per.PerNom' },
                { text: 'Enviado', width: 70, sortable: false, value: 'Enviado' }
            ],
            dtOptionsLoaded: false,
            filtros: {
                FechaDesde: null,
                FechaHasta: null,
                Proveedor: {}
            },
            newPedidoProveedor: null,
            numeroAlbaran: '',
            fechaAlbaran: null,
        }
    },
    watch: {
      options: {
        handler () {
          if(!this.dtOptionsLoaded){
            this.dtOptionsLoaded = true;
            return;
          }
          this.loadData();
        },
        deep: true
      },
      filtros: {
        handler () {
          this.loadData();
        },
        deep: true
      },
      loading: {
        handler() {
          if (this.loading) {
            this.$refs.provCtrl.$refs.FindCtrl.isMenuActive = false;
          }
        },
        deep: true
      },
      isTahona(val) {
        if (val) this.numeroAlbaran = ''
        else this.fechaAlbaran = null
      },
    },
    mounted() {
      this.loadData();
    },
    methods: {
      getDataFromApi() {
        this.loading = true;

        var NumRegsPag = this.options.itemsPerPage;
        var NumPag = this.options.page;

        return new Promise((resolve) => {
          const controllerParameters = {
            NumRegsPag: NumRegsPag,
            NumPag: NumPag,
            DirId: this.dirId,
            EmpId: this.empId,
            FechaDesde: this.filtros.FechaDesde,
            FechaHasta: this.filtros.FechaHasta,
            Proveedor: this.filtros.Proveedor != null ? this.filtros.Proveedor.xproveedor_id : null
          };       
          const AuthToken = localStorage.getItem('token');
          axios({ method: "POST", "url": this.urlRaiz + "/api/albaranes/list", "data": JSON.stringify(controllerParameters), "headers": {"content-type": "application/json", "Authorization": AuthToken } })
          .then(result => {
            const items = result.data.EntsList;
            const total = result.data.EntsTotCount;

            setTimeout(() => {
                this.loading = false
                resolve({
                items,
                total,
              })
            }, 1000)
          })
          .catch(error => {
            if(error != null) {
                this.loading = false;
                alert("Error al cargar los albaranes");
            }
          });
        })
      },
      newDataFromApi(pedidoId, proveedorId, proveedor, numeroAlbaran, fechaAlbaran) {
        this.loading = true;

        return new Promise((resolve) => {
          const controllerParameters = {
            DirId: this.dirId,
            PerId: this.perIdAux === 0 ? this.perId : this.perIdAux, // ← aquí
            PedidoId: pedidoId,
            ProveedorId: proveedorId,
            Proveedor: proveedor,
            EmpId: this.empId,
            NumeroAlbaran: numeroAlbaran,
            FechaAlbaran: fechaAlbaran
          };       
          const AuthToken = localStorage.getItem('token');
          axios({ method: "POST", "url": this.urlRaiz + "/api/albaranes/new", "data": JSON.stringify(controllerParameters), "headers": {"content-type": "application/json", "Authorization": AuthToken } })
          .then(result => {
            const created = result.data;

            setTimeout(() => {
                this.loading = false
                resolve({
                  created
                })
            }, 1000)
          })
          .catch(error => {
            if(error != null) {
                this.loading = false;
                alert("Error al cargar los albaranes");
            }
          });
        })
      },

      loadData(){
        this.getDataFromApi()
        .then(data => {
          this.dataRows = data.items
          this.totalDataRows = data.total
        });
      },
      onClickRowEditarAlbaran(item){
        this.$router.push('/albaran-editar/' + item.AlbaranId);
      },
      openCreateDialog() {
        this.$refs.pedidosSearch.loadDataAbaranes();
        this.showCreateDialog = true;
      },
      onBtnClose() {
        this.showCreateDialog = false;
        this.newPedidoProveedor = null;
        this.numeroAlbaran = '';
        this.fechaAlbaran = null;
      },
      toogleFilters() {
        this.activePanels = this.activePanels == null ? 0 : undefined;
      },
      onSelect(item)
      {
        if (item == null) return;
        this.createNew(item.PedidoId, null); 
      },
      onClickNewPedido() {
        if (!this.newPedidoProveedor) return;

        const numero = this.isTahona ? null : (this.numeroAlbaran || '');
        const fecha  = this.isTahona ? (this.fechaAlbaran || null) : null;

        this.createNew(null, this.newPedidoProveedor, numero, fecha);
      },
      createNew(pedidoId, proveedor, numeroAlbaran, fechaAlbaran)
      {
        const proveedorId = proveedor != null ? proveedor.xproveedor_id : '';
        const proveedorName = proveedor != null ? proveedor.xnomabrev : '';

        this.newDataFromApi(pedidoId, proveedorId, proveedorName, numeroAlbaran, fechaAlbaran)
          .then(data => {
            if (data.created === true)
            {
              this.showCreateDialog = false;
              this.newPedidoProveedor = null;
              this.numeroAlbaran = '';
              this.fechaAlbaran = null;
              this.loadData();
            }
          }); 
      },
      // onSelect(item)
      // {
      //   if (item == null) return;
      //   this.newDataFromApi(item.PedidoId)
      //     .then(data => {
      //       if (data.created === true)
      //       {
      //         this.showCreateDialog = false;
      //         this.loadData();
      //       }
      //     }); 
      // },
      formatDate(value)
      {
          return funcs.formatDate(value);
      }
    } 
})
</script>
